import React from 'react'
import { TableSection } from './micro-components/TableSection';
import Title from './micro-components/Title';
import Container from './micro-components/Container';
import { cn } from '@/lib/utils';

export type GenericRow = { criteria: string; rating: number | string; remarks: string };

const GenericContent: React.FC<{
    title?: string;
    rows: GenericRow[];
    showTitle?: boolean;
    tableSectionClassName?: string;
    className?: string;
}> = ({ title, rows, showTitle = true, tableSectionClassName, className }) => {
    return (
        <div>
            {showTitle && title ? <Title title={title} /> : null}
            <TableSection
                className={tableSectionClassName}
                title={title}
                rows={
                    rows.map((item) => ({
                        criteria: item.criteria,
                        rating: item.rating,
                        remarks: item.remarks,
                    }))
                }
            />
        </div>

    )
}

export default GenericContent